import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { Store } from '@ngrx/store';

import { connectToWebsocket } from '@core/stores/websocket/websocket.actions';

export const websocketInitializer: EnvironmentProviders = provideAppInitializer(() => {
  const store = inject(Store);
  store.dispatch(connectToWebsocket());
});
